module.exports = __webpack_public_path__ + "img/disabled_button.b2b42d78.svg";